export default __webpack_public_path__ + "static/media/avatar-mp-2-2.101205b3.png";